module.exports = __webpack_public_path__ + "img/pztype-5.1e89a97b.png";